import { VorgangProtokollAction } from '@core/domain';
import { VorgangDetail, VorgangDetailProtokoll } from '../../../types';

/**
 * Get the previous payload for a step
 * in case the step has manually been (re)started.
 */
export const getPreviousPayloadForSchritt = ({
  schritt,
  abarbeitungId,
  abarbeitungen,
  protokoll = [],
}: {
  schritt: VorgangDetail['abarbeitungen'][number]['schritte'][number];
  abarbeitungId: string;
  abarbeitungen: VorgangDetail['abarbeitungen'];
  protokoll: VorgangDetailProtokoll;
}) => {
  const abarbeitung = abarbeitungen.find((a) => a.id === abarbeitungId);
  if (!abarbeitung) {
    return null;
  }

  /**
   * In the following cases, there's no payload to compare with:
   * * The abarbeitung was started by the system
   * * It's the first run of the vorgang
   */
  if (abarbeitung.initiator === 'system' || abarbeitung.laufnummer === 1) {
    return null;
  }

  const previousAbarbeitung = abarbeitungen.find(
    (a) => a.laufnummer === abarbeitung.laufnummer - 1,
  );

  if (!previousAbarbeitung) {
    return null;
  }

  const previousSchritt = previousAbarbeitung.schritte.find(
    (s) => s.schritt === schritt.schritt,
  );

  if (!previousSchritt) {
    return null;
  }

  /**
   * Wenn der vorherige Schritt Zwischenspeicherungen hat,
   * wird der älteste bekannte Payload verwendet. Dadurch
   * zeigt das Diff alle Unterschiede an - nicht nur die seit
   * der letzten Zwischenspeicherung.
   */
  const zwischenSpeicherungenVonVorherigenSchritt = protokoll.filter(
    (item) =>
      item.action === VorgangProtokollAction.SCHRITT_ZWISCHENSPEICHERN &&
      item.details.schrittId === previousSchritt.id,
  );

  if (zwischenSpeicherungenVonVorherigenSchritt.length > 0) {
    return zwischenSpeicherungenVonVorherigenSchritt[0].details.previousPayload;
  }

  return previousSchritt.initialPayload;
};
